import { DocumentAttachment } from "@customTypes/responses/document";
import React from "react";
import AttachmentItem from "./AttachmentItem";

type AttachmentListProps = {
  attachments: DocumentAttachment[];
};
const AttachmentList: React.FC<AttachmentListProps> = ({ attachments }) => {
  return (
    <>
      {attachments.map((attachment, i) => (
        <AttachmentItem attachment={attachment} key={`${attachment.fileName}:${i}`} />
      ))}
    </>
  );
};

export default AttachmentList;
